var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":_vm.$t('general.titleHomePage')}},[_c('b-card-text',[_vm._v(_vm._s(_vm.$t('general.welcomeHomePage')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }